"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeQueryString = void 0;
var queryString = require("query-string");
var mergeQueryString = function (query, params, filterQueryParams) {
    var queryObj = queryString.parse(query);
    var paramObj = typeof params === 'string' ? queryString.parse(params) : params;
    if (filterQueryParams) {
        Object.keys(queryObj).forEach(function (key) {
            if (!filterQueryParams(key)) {
                delete queryObj[key];
            }
        });
    }
    return queryString.stringify(__assign(__assign({}, queryObj), paramObj));
};
exports.mergeQueryString = mergeQueryString;
//# sourceMappingURL=merge-query-string.js.map